import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../../utils/helpers';

export const GET_APP_VERSION = 'GET_APP_VERSION';
export const GET_APP_VERSION_SUCCESS = 'GET_APP_VERSION_SUCCESS';
export const GET_APP_VERSION_FAIL = 'GET_APP_VERSION_FAIL';

export const UPDATE_APP_VERSION = 'UPDATE_APP_VERSION';
export const UPDATE_APP_VERSION_SUCCESS = 'UPDATE_APP_VERSION_SUCCESS';
export const UPDATE_APP_VERSION_FAIL = 'UPDATE_APP_VERSION_FAIL';
export const UPDATE_APP_VERSION_RESET = 'UPDATE_APP_VERSION_RESET';

export const getAppVersionApi = () => {
  return (dispatch) => {
    dispatch({ type: GET_APP_VERSION });
    axios
      .get(`${config.api.base_url}/settings/app_version`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch({ type: GET_APP_VERSION_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: GET_APP_VERSION_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const updateAppVersionApi = (value, action) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_APP_VERSION });
    const body = action ? { value, action } : { value };
    axios
      .put(
        `${config.api.base_url}/settings/app_version`,
        body,
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => {
        dispatch({ type: UPDATE_APP_VERSION_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: UPDATE_APP_VERSION_FAIL, response: error.response?.data || error.message });
      });
  };
};

export const updateAppVersionReset = () => ({ type: UPDATE_APP_VERSION_RESET });
